export default "__VITE_ASSET__By0qbZq0__"